import { Grid, useMediaQuery } from '@mui/material';
import Title from '../../@iosper/components/Page/Title';
import CardButton from '../../@iosper/components/Card/CardButton';
import ordenImg from '../../assets/images/menu/orden.svg';
import ordenBusquedaImg from '../../assets/images/menu/orden-busqueda.svg';
import { useTheme } from '@emotion/react';

const Reintegros = () => {
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <>
      <Title>Reintegros</Title>

      <Grid container spacing={2}>
        {/* <Grid item xs={4} sm={4} lg={4}>
          <CardButton
            title={'Solicitar Reintegro'}
            description={'Generá reintegros.'}
            to={'/reintegros/consulta'}
            image={ordenImg}
            isMobile={isMobileScreen}
          />
        </Grid> */}
        <Grid item xs={4} sm={4} lg={4}>
          <CardButton
            title={'Consultar Reintegros Liquidados'}
            description={'Consultá los reintegros liquidados.'}
            to={'/reintegros/busqueda'}
            image={ordenBusquedaImg}
            isMobile={isMobileScreen}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default Reintegros;
